import {Component, EventEmitter, Input, Output} from "@angular/core";
import {Promotion} from "@app/core/promotion/domain/dtos/promotion";
import {
    AddPromotionToCartButtonModule
} from "@app/presentation/components/add-promotion-to-cart-button/add-promotion-to-cart-button.module";
import {CommonModule} from "@angular/common";
import {LocalizedCurrencyModule} from "@app/presentation/pipes/localized-currency/localized-currency.module";
import {TranslateModule} from "@ngx-translate/core";
import {LocalizedDateModule} from "@app/presentation/pipes/localized-date/localized-date.module";

@Component({
    standalone: true,
    selector: 'app-promotion-list-tile',
    templateUrl: './promotion-list-tile.component.html',
    imports: [
        AddPromotionToCartButtonModule,
        CommonModule,
        LocalizedCurrencyModule,
        TranslateModule,
        LocalizedDateModule
    ],
    styleUrls: ['./promotion-list-tile.component.scss']
})
export class PromotionListTileComponent {
    @Input() promotion!: Promotion;

    @Input() canDisplayPrice: boolean = true;

    @Input() isClickable: boolean = false;

    @Output() onClick = new EventEmitter<Promotion>();
}
